import { payAgainApi } from '@/api/order'
import { wechatPay, wxMpPay } from '@/utils/payment/wechatPay'
import store from '@/store'
import { judgeUserAgent } from '@/utils/judgeUserAgent'

/**
 * 获取用户 openId
 */
const getOpenId = () => {
  return store.getters.userInfo.openId || ''
}

/**
 * 获取微信支付类型
 * @returns {number} 1: JSSDK | 2: WeixinJSBridge | 3: 小程序 | 4: H5
 */
const getWxPayType = () => {
  if (judgeUserAgent('WXMP')) return 3 // 微信小程序
  if (judgeUserAgent('WXWEB')) return 2 // 微信公众号
  if (judgeUserAgent('WXH5')) return 4 // 非微信浏览器
  return 1
}

/**
 * 处理项目卡支付
 */
const handleProjectCardPay = (data) => {
  const payment = data.payment
  
  if (payment.pay_status === false && payment.pay_data.jump_to_payment === true) {
    window.location.href = payment.pay_data.jump_to_payment_url
    return null
  }
  
  return data
}

/**
 * 处理微信支付
 */
const handleWechatPay = async (payData, orderSn, payId) => {
  const weiChatPay = await wechatPay({
    payData,
    order_sn: orderSn,
    pay_id: payId
  })

  return {
    status: weiChatPay.status,
    msg: weiChatPay.status ? '支付成功' : weiChatPay.msg
  }
}

/**
 * 单笔支付处理
 */
const paymentAgain = async (data) => {
  const wxPayType = getWxPayType()

  // 小程序环境微信支付
  if (wxPayType === 3 && data.pay_type === 3) {
    wxMpPay({
      pay_id: data.pay_id,
      order_sn: data.order_sn
    })
    return Promise.reject('支付中')
  }

  const params = {
    pay_id: data.pay_id,
    openid: data.pay_type === 3 ? getOpenId() : undefined,
    wx_pay_type: data.pay_type === 3 ? wxPayType : undefined
  }

  const result = await payAgainApi(params)

  if (!result.data.data.status) {
    return result.data.data
  }

  // 项目卡支付
  if (data.pay_type === 23) {
    return handleProjectCardPay(result.data.data)
  }

  // 微信支付
  if (data.pay_type === 3) {
    const payData = result.data.data.payment.pay_data
    return handleWechatPay(payData, data.order_sn, data.pay_id)
  }

  return result.data.data
}

/**
 * 批量支付处理（支持混合支付）
 * @param {Object} context - Vuex context
 * @param {Array} data - 支付信息数组
 * @param {string} data[].pay_id - 订单编号
 * @param {number} data[].payType - 支付类型（1:积分 | 2:余额 | 3:微信 | 20:混合 | 21:福利卡 | 23:项目卡）
 * @param {string} data.order_sn - 订单编号
 */
const payAgain = async ({ dispatch }, data) => {
  const results = []
  
  // 微信支付排在最后
  const sortedData = data.sort((a, b) => (a.payType === 3 ? 1 : -1))

  try {
    for (const payInfo of sortedData) {
      const result = await paymentAgain({
        pay_id: payInfo.pay_id,
        pay_type: payInfo.payType,
        order_sn: data.order_sn
      })

      results.push(result)

      if (!result.status) {
        return Promise.resolve(result)
      }
    }

    return Promise.resolve({
      status: true,
      msg: '支付成功'
    })
  } catch (error) {
    return Promise.resolve({
      status: false,
      msg: error
    })
  }
}

export default payAgain
